import { gql } from "@apollo/client";

export const userLogin = gql`
  mutation Login($input: LoginInput) {
    login(input: $input) {
      user {
        terms_of_service
        clientable {
          ... on Insurer_associate {
            assoc_first_name
            assoc_last_name
            assoc_primary_phonenumber
            assoc_secondary_phonenumber
            assoc_email
            position
            insurer {
              insurer_company_name
              insurer_company_email
            }
          }
          ... on Reinsurer_representative {
            rep_first_name
            rep_last_name
            rep_primary_phonenumber
            rep_secondary_phonenumber
            rep_email
            position
            reinsurer {
              reinsurer_id
              re_company_name
              re_company_email
              re_company_website
            }
            auth_config {
              otp_enabled
              has_disabled_otp_before
            }
            export_iriskre_id
            export_kek_id
            export_visalre_id
          }
        }
        id
        email
      }
      access_token
      refresh_token
      expires_in
      token_type
    }
  }
`;
export const getOTP = gql`
  mutation GenerateOtp($args: OtpInput) {
    generateOtp(args: $args) {
      success
      message
      otp
    }
  }
`;
export const validateOTP = gql`
  mutation ValidateOtp($args: OtpValidationInput) {
    validateOtp(args: $args) {
      success
      message
    }
  }
`;

export const setLoginPassword = gql`
  mutation SetLoginPassword($input: LoginPassword!) {
    setLoginPassword(input: $input)
  }
`;

export const enableOTP = gql`
  mutation EnableOTPAuthentication($input: EnableOtpInput!) {
    enableOTPAuthentication(input: $input) {
      success
      message
    }
  }
`;
export const disableOTP = gql`
  mutation DisableOTPAuthentication($input: DisableOtpInput!) {
    disableOTPAuthentication(input: $input) {
      success
      is_first_time_disable
      message
    }
  }
`;

export const forgetPassword = gql`
  mutation ForgottenPassword($input: ForgotPasswordInput!) {
    forgottenPassword(input: $input) {
      status
      message
    }
  }
`;

export const resetPassword = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      status
      message
    }
  }
`;
